import { useEffect, useState } from 'react'
import Default from 'components/layouts/Default/Default';
import DownloadPage from 'components/templates/Downloads/DownloadPage';

const Downloads = () => {

  return (
    <Default>
        <div className="row">

          <div className="col-12 text-white d-flex">
            <h3 className="pb-2">Downloads</h3>
          </div>
          <div className="col-12">
            <DownloadPage />
          </div>
          
        </div>

    </Default>
  )
}
// const dashboard = () => {
//     return (<div>Dashboard</div>)
// }
export default (Downloads);